import {MalformedPathError} from './MalformedPathError.class';

export function getPrettyUrlPath(path: string) {
  if (/(\/\/+)|(\?)/.test(path)) {
    throw new MalformedPathError();
  }

  const fixedPath = `/${path.replace(/^\//, '')}`;
  return fixedPath;
}
